import { render } from "./MenuClassic.vue?vue&type=template&id=f620291a&scoped=true"
import script from "./MenuClassic.vue?vue&type=script&lang=js"
export * from "./MenuClassic.vue?vue&type=script&lang=js"

import "./MenuClassic.vue?vue&type=style&index=0&id=f620291a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f620291a"]])

export default __exports__